// Cabeçalhos transversais da API GIYUS (Parte 13.1).
export const HEADERS = {
  authorization: 'Authorization',
  correlationId: 'X-Correlation-Id',
  acceptLanguage: 'Accept-Language',
  purpose: 'X-Purpose',
  idempotencyKey: 'Idempotency-Key',
  ifMatch: 'If-Match',
  etag: 'ETag',
  idempotentReplayed: 'Idempotent-Replayed',
  retryAfter: 'Retry-After',
} as const;

export const PROBLEM_JSON = 'application/problem+json';

/** Métodos que exigem `Idempotency-Key` quando o endpoint é idempotente. */
export const MUTATING_METHODS: ReadonlySet<string> = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

/** Formato aceito para `X-Correlation-Id` (kernel: `^[A-Za-z0-9._-]{1,64}$`). */
export const CORRELATION_ID_PATTERN = /^[A-Za-z0-9._-]{1,64}$/;

/** Propósito declarado para leituras sensíveis: `code; text=...` (texto opcional). */
export interface DeclaredPurpose {
  readonly code: string;
  readonly text?: string;
}

export function formatPurposeHeader(purpose: DeclaredPurpose): string {
  const text = purpose.text?.trim();
  return text ? `${purpose.code}; text=${text}` : purpose.code;
}
